export const FocusElement = {
  mounted() {
    this.handleEvent("focus_element", ({ id }) => {
      const el = document.getElementById(id);
      if (el) {
        el.focus();
      }
    });
  },
};
